(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blunook-home-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blunook-home-showcase')) {
    customElements.define('blunook-home-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        this.paused = false;
        this.visible = true;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.counter = this.querySelector('[data-counter]');
        this.announcement = this.querySelector('[data-announcement]');
        this.pauseButton = this.querySelector('[data-pause]');
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.pauseButton?.addEventListener('click', () => {
          this.paused = !this.paused;
          document.body.dataset.bnHomePaused = String(this.paused);
          this.pauseButton.setAttribute('aria-pressed', String(this.paused));
          this.pauseButton.querySelector('[data-motion-label]').textContent = this.paused ? this.pauseButton.dataset.resumeLabel : this.pauseButton.dataset.pauseLabel;
        });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
          this.observer.observe(this);
        }
        if (this.slides.length > 1 && this.dataset.autoplay === 'true') {
          this.timer = window.setInterval(() => {
            if (!this.paused && !this.reducedMotion.matches && this.visible && !document.hidden) this.show(this.index + 1, false);
          }, Number(this.dataset.interval) || 6000);
        }
        const prepare = () => { this.slides.forEach(slide => { const image = slide.querySelector('img'); if (image) image.loading = 'eager'; }); };
        if ('requestIdleCallback' in window) this.idleId = window.requestIdleCallback(prepare, { timeout: 2500 });
        else this.preloadTimer = window.setTimeout(prepare, 1800);
        this.show(0, false);
      }
      show(index, manual) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
          slide.querySelectorAll('a').forEach(link => { link.tabIndex = active ? 0 : -1; });
        });
        if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0') + ' / ' + String(this.slides.length).padStart(2, '0');
        if (manual && this.announcement) this.announcement.textContent = this.slides[this.index].dataset.title;
      }
      disconnectedCallback() {
        window.clearInterval(this.timer);
        window.clearTimeout(this.preloadTimer);
        if (this.idleId && 'cancelIdleCallback' in window) window.cancelIdleCallback(this.idleId);
        this.observer?.disconnect();
        document.body.removeAttribute('data-bn-home-paused');
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
